



















import {Vue, Component} from 'vue-property-decorator';
import NumberPad from '@/components/Money/NumberPad.vue';
import FormItem from '@/components/Money/FormItem.vue';
import Tags from '@/components/Money/Tags.vue';
import Tabs from '@/components/Tabs.vue';
import recordTypeList from '@/consts/recordTypeList';

@Component({
  components: {Tabs, Tags,  FormItem, NumberPad},
})

export default class Money extends Vue {
  record: RecordItem = {
    tags: [], notes: '', type: '-',amount: 0, createdAt: new Date().toISOString()
  }
  get recordList(){
    return this.$store.state.recordList
  }

 get currentHeight(){
    return  document.documentElement.clientHeight
 }

  recordTypeList = recordTypeList

  beforeCreate(){
    this.$store.commit('fetchRecords')
  }

  onUpdateNotes(value: string){
    this.record.notes = value
  }
  savaRecord(){
    if(!this.record || this.record.tags.length ==0){
     return window.alert('请至少选择一个标签')
    }
    this.$store.commit('createRecord', this.record);
    if(this.$store.state.createRecordError === null){
      window.alert('您有一笔账单已记录在册')
      this.record.notes = ''
    }
  }
}

